/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Neat_Swan_PantInputs */

const en_wry_neat_swan_pant = /** @type {(inputs: Wry_Neat_Swan_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive Surveys`)
};

const de_wry_neat_swan_pant = /** @type {(inputs: Wry_Neat_Swan_PantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Befragungen erhalten`)
};

/**
* | output |
* | --- |
* | "Receive Surveys" |
*
* @param {Wry_Neat_Swan_PantInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_neat_swan_pant = /** @type {((inputs?: Wry_Neat_Swan_PantInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Neat_Swan_PantInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_neat_swan_pant(inputs)
	return de_wry_neat_swan_pant(inputs)
});